import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import ModuleWithLoader from '../components/ModuleWithLoader'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import { NETWORK_TELSTRA, SERVICE_MOBILE, providers, TYPE_PREPAID, TYPE_POSTPAID, SIM_TYPE_3IN1, SIM_TYPE_ESIM } from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import globals from '../globals'
import MobilePlanAdditionalData from '../components/MobilePlanAdditionalData'
import MobilePlanAdditionalText from '../components/MobilePlanAdditionalText'
import Addressify from '../elements/Addressify'
import CustomLink from '../components/CustomLink'
import { connect } from 'react-redux'
import InputRow from '../elements/InputRow'
import FancyToggle from '../elements/FancyToggle'
import VerifyMobile from '../elements/VerifyMobile'
import ReactModal from '../modules/ReactModal'
import simData from '../../data/esimModal/eSim.json'
import DataStore from '../DataStore'
import Error from '../components/Error'

const options = {
    postUrl: '/api/postCrossMobile',
    success: 'Thank you for your ExeSIM Mobile SIM order. You will receive a confirmation email shortly.'
}

const state = {
    serviceId: null,
    planId: null,
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryCompany: '',
    deliveryAddress: '',
    homeAddress: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    termsOfUse: false,
    termsAndConditions: false,
    currentProviderNumber: '',
    mobileNumber: '',
    currentProvider: '',
    currentProviderPlanType: '',
    newMobileNumber: '',
    keepCurrentMobileNumber: null,
    agentCode: '',
    simType: '',
    accNumberError: ''
}

class CrossMobileForm extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            currentPlan: {},
            mobileIsVerified: false,
            verifyErrorMessage: '',
            keepCurrentMobileNumberErrorMessage: '',
            showModal: false,
            isActive: ''
        }
    }

    componentDidMount() {
        this.getServiceData()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.defaultPlan !== this.props.defaultPlan) {
            this.setState({ currentPlan: this.props.defaultPlan })
        }
    }

    async getServiceData () {
        DataSource.getData(`/api/getServices/${this.props.customerId}`, result => {
            let address = ''
            if (result.broadband && result.broadband.length > 0) {
                address = result.broadband[result.broadband.length-1].address
            } else if (result.mobile && result.mobile.length > 0) {
                address = result.mobile[result.mobile.length-1].serviceAddress
            }
            this.props.setDynamicValues({homeAddress: address, deliveryAddress: address})
        }, () => {
            // No need to handle, just don't prefill address
        })
    }

    setCurrentPlan () {
        this.props.plans.map(plan => {
            if (this.props.values.planId === plan.id) {
                this.setState({ currentPlan: plan })
            }
        })
    }

    handleChangePlan (id) {
        this.props.setDynamicValues({
            planId: id
        }, this.setCurrentPlan.bind(this))
    }

    handleChangeAccNumber(event) {
        if (!globals.checkNumber(event.target.value)){
            this.setState({accNumberError: 'Please use digits only (0–9) for the account number.'})
        } else {
            this.setState({accNumberError: ''})
        }
        this.props.handleInputChange(event)
    }

    handleChange (event) {
        this.props.handleInputChange(event)
    }

    mapExistingPlanFields () {
        return {
            title: 'N/A',
            data: '',
            speed: '',
            eveningSpeed: '',
            price: '',
            features: []
        }
    }

    mapApiPlanFields () {
        const plans = []

        this.props.plans.forEach(plan => {
            const additionalText1 = plan.features.length >= 3 ? <MobilePlanAdditionalText content={[plan.features[1], plan.features[2]]} /> : ''
            const additionalText2 = plan.features.length >= 4 ? <MobilePlanAdditionalText content={plan.features[3] ? [plan.features[3]] : []} /> : ''

            plans.push({
                id: plan.id,
                title: plan.title,
                subHeading: plan.subHeading,
                data: <span className='bold'>{plan.data}</span>,
                special: plan.special ? plan.special : null,
                price: plan.price,
                features: plan.features[0] ? [plan.features[0]] : [],
                additionalText1: additionalText1,
                additionalText2: additionalText2,
                costPerGb: plan.costPerGb,
                totalMinCost: plan.id === 413 ? '0' : plan.price,
                priceNotes: plan.priceNotes
            })
        })

        return plans
    }

    getProviders () {
        const data = []
        providers.forEach(item => {
            data.push({ label: item, value: item })
        })
        return data
    }

    handleSubmitCrossMobileForm () {
        this.setState({ verifyErrorMessage: '' })
        if (this.props.values.keepCurrentMobileNumber) {
            if (!this.state.mobileIsVerified || (this.props.values.mobileNumber !== DataStore.getItem("verifiedMobileNumber"))) {
                this.setState({ verifyErrorMessage: 'You need to verify the mobile number you\'re keeping above by clicking the "Send code" button and verifying it' })
                return
            } else if(this.state.accNumberError && this.props.values.currentProviderPlanType === TYPE_POSTPAID) {
                return    
            } else {
                this.props.handleSubmit()
            }
        } else if (this.props.values.keepCurrentMobileNumber === null) {
            this.setState({ keepCurrentMobileNumberErrorMessage: 'Please choose whether you want to keep your current mobile number!' })
        } else {
            this.props.handleSubmit()
        }
    }

    keepMobileNumber () {
        return (
            <div>
                <div className='delivery-name d-md-flex d-none'>
                    <div>
                        <p className='font-small sub-bold m-0 mb-1'>
                            Your mobile number
                        </p>
                        <InputRow
                            name='mobileNumber'
                            value={this.props.values.mobileNumber}
                            errors={this.props.errors}
                            handleChange={this.handleChange.bind(this)}
                            placeholder='Mobile number'
                            hideLabel
                        />
                    </div>
                    <div>
                        <p className='font-small sub-bold m-0 mb-1'>
                            Select your current provider
                        </p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={this.getProviders()}
                            value={this.props.values.currentProvider}
                            placeholder='Select provider'
                            label=''
                            name='currentProvider'
                            handleChange={this.props.setDynamicValues}
                            errors={this.props.errors}
                        />
                    </div>
                    <div>
                        <p className='font-small sub-bold m-0 mb-1'>
                            Currently on a plan? Or prepaid?
                        </p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={[
                                {
                                    label: 'Pre-paid service',
                                    value: TYPE_PREPAID
                                },
                                {
                                    label: 'On a plan',
                                    value: TYPE_POSTPAID
                                }
                            ]}
                            value={this.props.values.currentProviderPlanType}
                            label=''
                            name='currentProviderPlanType'
                            handleChange={this.props.setDynamicValues}
                            errors={this.props.errors}
                        />
                    </div>
                </div>
                {this.props.values.currentProviderPlanType === TYPE_PREPAID
                    ? <div className='d-lg-flex d-none delivery-name mt-3 mb-3 justify-content-between align-items-center'>
                        <p className='font-small sub-bold mb-1 mr-3'>
                            Date of birth on your current prepaid account?
                        </p>
                        <InputRow
                            hideLabel
                            name='dateOfBirth'
                            value={this.props.values.dateOfBirth}
                            handleChange={this.handleChange.bind(this)}
                            placeholder='DD/MM/YYYY'
                            type='date'
                            autocomplete='bday'
                            errors={this.props.errors}
                        />
                    </div>
                    : <div className='d-md-flex d-none delivery-name mt-3 mb-3 justify-content-between align-items-center'>
                        <p className='font-small sub-bold mb-1 mr-3'>Account number</p>
                        <InputRow
                            hideLabel
                            name='currentProviderNumber'
                            value={this.props.values.currentProviderNumber}
                            handleChange={this.handleChangeAccNumber.bind(this)}
                            placeholder='Account Number'
                            errors={this.props.errors}
                            className={this.state.accNumberError ? 'error': ''}
                            max="30"
                        />
                        {this.state.accNumberError ? <Error errors={{error: this.state.accNumberError}} />: ''}
                    </div>}

                {/* Mobile Version */}
                {this.mobileFormVersion()}

                <VerifyMobile hasError={this.state.verifyErrorMessage} handleVerified={() => this.setState({ mobileIsVerified: true })} mobile={this.props.values.mobileNumber} />
                {this.state.verifyErrorMessage !== '' && <div className='mb-3 mt-3'>
                    <div className='row-error'>{this.state.verifyErrorMessage}</div>
                </div>}
            </div>
        )
    }

    notKeepMobileNumber () {
        return (
            <div>
                {this.state.hasError && this.props.mobileNumbers.length < 1
                    ? <div className='row-error'>Oops! Something went wrong. Please try again to see if the issue persists.</div>
                    : <div className='delivery-name d-flex justify-content-between align-items-center align-items-lg-start'>
                        <p className='font-small sub-bold m-0 mb-1 text-left'>Choose your new mobile number</p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={this.props.mobileNumbers}
                            value={this.props.values.newMobileNumber}
                            handleChange={this.props.setDynamicValues}
                            label=''
                            name='newMobileNumber'
                            errors={this.props.errors}
                        />
                    </div>}
            </div>
        )
    }

    mobileFormVersion () {
        return (
            <div className='d-md-none d-flex delivery-name mobile'>
                <div className='input-mobile'>
                    <p className='font-small sub-bold m-0 mb-1'>
                        Enter your mobile number:
                    </p>
                    <InputRow
                        name='mobileNumber'
                        value={this.props.values.mobileNumber}
                        errors={this.props.errors}
                        handleChange={this.handleChange.bind(this)}
                        placeholder=''
                        hideLabel
                    />
                </div>
                <div className='input-mobile'>
                    <p className='font-small sub-bold m-0 mb-1'>
                        Select your provider:
                    </p>
                    <FancySelectAdvancedRow
                        className='select-no-label'
                        options={this.getProviders()}
                        value={this.props.values.currentProvider}
                        placeholder=''
                        label=''
                        name='currentProvider'
                        handleChange={this.props.setDynamicValues}
                        errors={this.props.errors}
                    />
                </div>
                <div className='d-flex d-md-none plan-input-mobile' style={{ gap: '10px' }}>
                    <div className='d-flex flex-column w-50'>
                        <p className='font-small sub-bold m-0 mb-1'>
                            Current plan type:
                        </p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={[
                                {
                                    label: 'Pre-paid serivce',
                                    value: TYPE_PREPAID
                                },
                                {
                                    label: 'On a plan',
                                    value: TYPE_POSTPAID
                                }
                            ]}
                            value={this.props.values.currentProviderPlanType}
                            label=''
                            name='currentProviderPlanType'
                            handleChange={this.props.setDynamicValues}
                            errors={this.props.errors}
                        />
                    </div>

                    {this.props.values.currentProviderPlanType === TYPE_PREPAID
                        ? <div className='d-md-none d-flex flex-column w-50 mb-3'>
                            <p className='font-small m-0 mb-1 sub-bold'>Date of birth:</p>
                            <InputRow
                                hideLabel
                                name='dateBirth'
                                value={this.props.values.dateBirth}
                                handleChange={this.handleChange.bind(this)}
                                placeholder='DD/MM/YYYY'
                                type='date'
                                autocomplete='bday'
                                errors={this.props.errors}
                            />
                        </div>
                        : <div className='d-md-none d-flex flex-column w-50 mb-3'>
                            <p className='font-small m-0 mb-1 sub-bold'>Account number:</p>
                            <InputRow
                                hideLabel
                                name='currentProviderNumber'
                                value={this.props.values.currentProviderNumber}
                                handleChange={this.handleChangeAccNumber.bind(this)}
                                placeholder=''
                                errors={this.props.errors}
                                className={this.state.accNumberError ? 'error': ''}
                                max="30"
                            />
                            {this.state.accNumberError ? <Error errors={{error: this.state.accNumberError}} />: ''}
                        </div>}
                </div>
            </div>
        )
    }

    setSimType (simType, showModal) {
        this.props.values.simType = simType
        this.setState({ showModal: showModal, isActive: simType })
    }

    render () {
        return (
            <div className='migrate-mobile-form'>
                <div className='row'>
                    <div className='col-12 col-lg-8 offset-lg-2 mb-3'>
                        {this.props.children}
                    </div>
                </div>
                <ModuleWithLoader isLoaded={!this.props.isLoadingPlans} hasError={this.props.hasError}>
                    <React.Fragment>
                        {/* <Breadcrumbs /> */}
                        <div className='row'>
                            <div className='col-12 col-lg-12 px-2 px-lg-4 hide-current-plan'>
                                <h2
                                    className='text-center'
                                    dangerouslySetInnerHTML={{ __html: globals.noWidows('Choose your plan.') }}
                                />
                                <ComparePlans
                                    type={SERVICE_MOBILE}
                                    mobileNetwork={NETWORK_TELSTRA}
                                    plans={this.mapApiPlanFields()}
                                    existingPlan={this.mapExistingPlanFields()}
                                    handleSelect={this.handleChangePlan.bind(this)}
                                    selectedPlanId={this.state.currentPlan.id}
                                />
                            </div>
                        </div>
                        <div className='col-12 col-md-12 d-flex justify-content-center justify-content-md-center align-items-center'>
                            <CustomLink
                                to='https://www.exetel.com.au/mobilephone/charges'
                                className='color-grey underline'
                            >
                                View Rate Card
                            </CustomLink>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-12 col-lg-8 offset-lg-2'>
                                <label className='bold d-inline-block mt-3'>
                                    Service details
                                </label>
                                <div className='mb-4 mobile-number-toggle'>
                                    <div className='my-4 my-md-3 justify-content-between'>
                                        <div className='d-flex justify-content-between'>
                                            <p>Do you want an eSIM or a physical SIM</p>
                                            <div className='d-flex justify-content-end'>
                                                <button
                                                    className={`esim-button ${this.props.values.simType === SIM_TYPE_ESIM ? 'active' : ''}`}
                                                    onClick={() => this.setSimType(SIM_TYPE_ESIM, true)}
                                                    value={this.props.values.simType}
                                                    style={{ marginRight: '15px' }}
                                                >eSIM
                                                </button>

                                                <button
                                                    className={`esim-button ${this.props.values.simType === SIM_TYPE_3IN1 ? 'active' : ''}`}
                                                    onClick={() => this.setSimType(SIM_TYPE_3IN1, false)}
                                                    value={this.props.values.simType}
                                                >Physical
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ReactModal
                                    showModal={this.state.showModal} handleCloseModal={() => this.setState({ showModal: false })}
                                >
                                    <div className='text-center pt-3'>
                                        <div className='bold font-large mt-3'>Supported handsets</div>
                                        <p>Excited to use eSIM? Check our most popular eSIM capable devices:</p>
                                    </div>
                                    <div className='mt-3 border-top'>
                                        <div className='d-md-flex d-inlin-block flex-row justify-content-between'>
                                            <div className='mt-4'>
                                                <div className='bold'>Apple</div>
                                                <div className='m-0 mt-3 p-0 list-unstyled'>
                                                    {simData.apple.map((item, index) => {
                                                        return (
                                                            <p key={index}>{item}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            <div className='mt-4'>
                                                <div className='bold p-0'>Samsung</div>
                                                <div className='m-0 mt-3 p-0 list-unstyled'>
                                                    {simData.samsung.map((item, index) => {
                                                        return (
                                                            <p key={index}>{item}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            <div className='mt-4'>
                                                <div className='bold'>Google</div>
                                                <div className='m-0 mt-3 p-0 list-unstyled'>
                                                    {simData.google.map((item, index) => {
                                                        return (
                                                            <p key={index}>{item}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <p className='bold m-0'>Additional information:</p>
                                        <p className='mx-0'>If you can't find your device in this list, try checking with the manufacturer.</p>
                                        <p className='mt-3'><span className='bold'>Note: </span>Handsets purchased in China may not be eSIM capable.</p>
                                    </div>
                                </ReactModal>
                                <div className='d-none d-md-block'>
                                    <FancyToggle
                                        title='Do you want to keep your current mobile number?'
                                        name='keepCurrentMobileNumber'
                                        value={this.props.values.keepCurrentMobileNumber}
                                        handleChange={this.props.setDynamicValues}
                                        titleYes='Yes'
                                        titleNo='No, I need a new number'
                                        className='mobile-number-toggle'
                                    />
                                </div>
                                <div className='d-block d-md-none cross-mobile-selection'>
                                    <FancyToggle
                                        title='Do you want to keep your current mobile number?'
                                        name='keepCurrentMobileNumber'
                                        value={this.props.values.keepCurrentMobileNumber}
                                        handleChange={this.props.setDynamicValues}
                                        titleYes='Yes'
                                        titleNo='No'
                                        className='mobile-number-toggle'
                                    />
                                </div>
                                {this.props.values.keepCurrentMobileNumber !== null ? (this.props.values.keepCurrentMobileNumber === true ? this.keepMobileNumber() : this.notKeepMobileNumber()) : (this.state.keepCurrentMobileNumberErrorMessage && <div className='row-error'>{this.state.keepCurrentMobileNumberErrorMessage}</div>)}
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-12 col-lg-8 offset-lg-2'>
                                <div>
                                    <label className={`bold d-inline-block ${this.props.values.simType !== SIM_TYPE_ESIM && 'mb-3'}`}>{this.props.values.simType === SIM_TYPE_ESIM ? 'Address' : 'Delivery'} details</label>
                                    {this.props.values.simType !== SIM_TYPE_ESIM && (
                                        <div className='delivery-name'>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>First name</p>
                                                <InputRow
                                                    name='deliveryFirstName'
                                                    value={this.props.values.deliveryFirstName}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder={window.innerWidth < 800 ? '' : 'First name'}
                                                    hideLabel
                                                />
                                            </div>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>Last name</p>
                                                <InputRow
                                                    name='deliveryLastName'
                                                    value={this.props.values.deliveryLastName}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder={window.innerWidth < 800 ? '' : 'Last name'}
                                                    hideLabel
                                                />
                                            </div>
                                            <div>
                                                <p className='font-small sub-bold m-0 mb-1'>Company name (if applicable)</p>
                                                <InputRow
                                                    name='deliveryCompany'
                                                    value={this.props.values.deliveryCompany}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                                    placeholder={window.innerWidth < 800 ? '' : 'Company name (if applicable)'}
                                                    hideLabel
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <Addressify
                                        label='Home address'
                                        name='homeAddress'
                                        value={this.props.values.homeAddress}
                                        errors={this.props.errors}
                                        handleSetAddress={this.props.setDynamicValues}
                                        placeholder={window.innerWidth < 800 ? '' : 'Start typing your home address'}
                                    >
                                        <small>So emergency services can find you if you call</small>
                                    </Addressify>
                                    {this.props.values.simType !== SIM_TYPE_ESIM && (
                                        <Addressify
                                            label='Delivery address'
                                            name='deliveryAddress'
                                            value={this.props.values.deliveryAddress}
                                            errors={this.props.errors}
                                            handleSetAddress={this.props.setDynamicValues}
                                            placeholder={window.innerWidth < 800 ? '' : 'If different from home address above'}
                                        >
                                            <small>We can't deliver to a PO Box</small>
                                        </Addressify>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='row my-3'>
                            <div className='col-12 col-lg-8 offset-lg-2'>
                                <label className={`bold d-inline-block mb-3`}>Terms & conditions</label>
                                <TermsOfUseCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsOfUse}
                                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                    cisUrl={this.state.currentPlan.cisLink ? this.state.currentPlan.cisLink : 'https://files.exetel.com.au/cis/mobile/2025-01-23/Exetel_Prepaid_Mobile_CIS.pdf'}
                                    termsUrl='https://www.exetel.com.au/mobilephone/faq-terms'
                                >
                                    I have less than 5 pre-paid mobile
                                    services and&nbsp;
                                </TermsOfUseCheckbox>
                                <br />
                                <TermsAndConditionsCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsAndConditions}
                                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                    type={SERVICE_MOBILE}
                                />
                                <br />
                                <p className="mb-0 mt-3 font-small">
                                    If you will have <span className="color-lime">5 (five)</span> or more prepaid services after this order, please contact our Customer Centre <a href="tel:133938" className="color-lime">13 39 38</a> to complete the required identity verification.
                                </p>
                            </div>
                        </div>
                        <div className='row my-4'>
                            <div className='col-12 col-md-4 offset-sm-0 offset-md-2 text-center text-lg-left my-2'>
                                <Button
                                    title='Order new plan & SIM'
                                    action={this.handleSubmitCrossMobileForm.bind(this)}
                                    className='spearmint-btn d-inline-block d-lg-none'
                                />
                                <Button
                                    title='Order new plan & SIM'
                                    action={this.handleSubmitCrossMobileForm.bind(this)}
                                    className='d-none d-lg-inline-block'
                                />
                            </div>
                            <div className='col-12 col-md-3 offset-lg-2 col-lg-2 align-items-center offset-md-3'>
                                <InputRow
                                    name='agentCode'
                                    value={this.props.values.agentCode}
                                    errors={this.props.errors}
                                    handleChange={this.handleChange.bind(this)}
                                    placeholder='Agent Code'
                                    hideLabel
                                />
                            </div>
                        </div>
                    </React.Fragment>
                </ModuleWithLoader>
            </div>
        )
    }
}

CrossMobileForm.propTypes = {
    handleSuccess: PropTypes.func,
    mobileNumbers: PropTypes.array.isRequired,
    plans: PropTypes.array.isRequired,
    isLoadingPlans: PropTypes.bool.isRequired,
    hasError: PropTypes.bool
}

const mapStateToProps = state => ({
    firstName: state.auth.firstName,
    lastName: state.auth.lastName,
    customerId: state.auth.id
})

export default connect(mapStateToProps, {})(FormHOC(CrossMobileForm, state, options))



// WEBPACK FOOTER //
// ./resources/js/forms/CrossMobileForm.js